import { gql } from '__generated__';

export default gql(`
  mutation AddInvitation($input: AddInvitationInput!) {
    addInvitation(input: $input) {
      id
    }
  }
`);
